import { OrtService } from '../../services/suchseite/ort.service';

export const MAXIMALER_SUCH_UMKREIS = 100;
export const MINIMALER_SUCH_UMKREIS = 5;

export function validiereSuchUmkreis(umkreis: string | null | undefined): string | null {
  if (umkreis === OrtService.UMKREIS_VALUE_GANZER_ORT) {
    return OrtService.UMKREIS_VALUE_GANZER_ORT;
  } else if (umkreis && !isNaN(parseInt(umkreis, 10))) {
    return Math.max(MINIMALER_SUCH_UMKREIS, Math.min(+umkreis, MAXIMALER_SUCH_UMKREIS)).toString();
  }
  return null;
}
